import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import LibraryCardButton from '../LibraryCardButtons/LibraryCardButton';
import MuxPlayer from '../MuxPlayer';
import { LibraryCardProps, VideoCardProps } from './cardData';
import { Icon } from '@iconify/react';
import eSStudent from '@iconify-icons/openmoji/family';
import playIcon from '@iconify-icons/carbon/play';
import lockAlt from '@iconify-icons/bx/lock-alt';
import styles from './LibraryCard.module.scss';

type Props = LibraryCardProps & VideoCardProps;

const VideoLibraryCard = ({
  isLocked,
  isWrongGrade,
  displayName,
  subtitle,
  content,
  assetId,
  featuredImage,
  gradeSpan,
}: Props): JSX.Element => {
  const [isShowPlayer, setShowPlayer] = useState(false);
  const history = useHistory();

  const handleClick = () => {
    isLocked || isWrongGrade ? null : setShowPlayer(true);
  };
  const handleHide = () => setShowPlayer(false);

  const getWrongGradeMessage = () => {
    return `Please switch to a classroom of grade ${Math.max(
      ...(gradeSpan as number[]),
    )} or lower to access this content`;
  };

  return (
    <>
      <div className={styles.container}>
        {!isLocked && (
          <div
            className={styles.imgContainer}
            onClick={handleClick}
            style={isLocked || isWrongGrade ? undefined : { cursor: 'pointer' }}
          >
            {isWrongGrade && (
              <div className={styles.wrongGrade}>
                <Icon icon={eSStudent} width={60} />
                Requires Different Grade Level
              </div>
            )}
            {!isWrongGrade && (
              <>
                <img className={styles.videoLibraryCardThumbnail} src={featuredImage} alt={displayName} />
                <div className={styles.videoOverlay}>
                  <Icon icon={playIcon} width={30} />
                </div>
              </>
            )}
          </div>
        )}
        {isLocked && (
          <div className={styles.imgContainer}>
            <div className={styles.locked}>
              <Icon icon={lockAlt} width={60} />
              Requires Peekapak PRO Subscription
              <span className={styles.upgrade} onClick={() => history.push('/activateTrial')}>
                Upgrade Now
              </span>
            </div>
          </div>
        )}
        <div className={styles.textContainer}>
          <h3 className={styles.typeHeading}>{subtitle && subtitle}</h3>
          <h2 className={styles.unitTitle}>{displayName && displayName}</h2>
          <p>{content}</p>
          <div className={styles.buttonRow}>
            {!isLocked && isWrongGrade && <p>{getWrongGradeMessage()}</p>}
            {!isLocked && !isWrongGrade && <LibraryCardButton buttonText='Watch' handleClick={handleClick} />}
          </div>
          {isLocked && <div className={styles.lockFill} />}
        </div>
      </div>
      {isShowPlayer && <MuxPlayer videoId={assetId} isShow={isShowPlayer} onHide={handleHide} title={displayName} />}
    </>
  );
};

export default VideoLibraryCard;
